import React from 'react';
import { IntegrationProps } from '../types';

export const BigCommerceSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Store Hash</label>
        <input
          type="text"
          value={config.storeHash || ''}
          onChange={(e) => onChange({ storeHash: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">X-Auth-Token</label>
        <input
          type="password"
          value={config.accessToken || ''}
          onChange={(e) => onChange({ accessToken: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};